import React, { useMemo } from 'react'
import { Redirect, useParams } from 'react-router-dom'

import { ROUTE_URLS } from 'router/routes'

import { useSlots } from 'modules/SlotsRoot/redefinitions/hooks'
import {
  isLegacySlotSection,
  resolveLegacySlotId,
  resolveLegacySlotMode,
} from 'modules/SlotsRoot/utils/resolveLegacySlotRedirect'

import { Spinner } from 'components/Spinner'

type LegacySlotRedirectParams = {
  sectionId?: string
  gameType?: string
  provider?: string
  gameId?: string
  suffix?: string
}

export const LegacySlotRedirect: React.FC = () => {
  const { sectionId, gameType, provider, gameId, suffix } = useParams<LegacySlotRedirectParams>()

  const {
    _slots: { list: slots, isLoading },
  } = useSlots({ place: 'casino', withoutRequests: false, isNeedAllCategories: true })

  const legacyGameId = gameId || ''
  const mode = resolveLegacySlotMode(suffix)

  const targetPath = useMemo(() => {
    const slotId = resolveLegacySlotId(legacyGameId, slots)

    if (!slotId) {
      return null
    }

    return ROUTE_URLS.SLOTS_FRAME(slotId, mode)
  }, [legacyGameId, mode, slots])

  if (sectionId && !isLegacySlotSection(sectionId)) {
    return <Redirect to={ROUTE_URLS.SLOTS('casino')} />
  }

  if (isLoading && !targetPath) {
    return <Spinner isLoading />
  }

  if (targetPath) {
    return <Redirect to={targetPath} />
  }

  if (gameType && provider && legacyGameId) {
    return <Redirect to={ROUTE_URLS.SLOTS('casino')} />
  }

  if (sectionId && legacyGameId) {
    return <Redirect to={ROUTE_URLS.SLOTS('casino')} />
  }

  return <Redirect to={ROUTE_URLS.SLOTS('casino')} />
}
